var render = function render(_c,_vm){return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 28 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"6","y":"1","width":"28","height":"5","rx":"2.5","transform":"rotate(45 6 1)","fill":"white"}}),_c('rect',{attrs:{"x":"2","y":"21","width":"28","height":"5","rx":"2.5","transform":"rotate(-45 2 21)","fill":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }